import React from "react";
import Page from "@jumbo/shared/Page";
import Login from "app/pages/AuthenticationPages/Login";
import ResetPassword from "app/pages/AuthenticationPages/ResetPassword";
import { getAuthToken } from "@jumbo/services/auth/jwtAuth";
import { Navigate } from "react-router-dom";
import ForgotPassword from "app/pages/AuthenticationPages/ForgotPassword";
//const auth = (getAuthToken() != null) ? true : null;
const auth = localStorage.getItem("access_token") != null ? true : null;

const AuthRoutes = [
  {
    path: "/login",
    element: auth ? (
      <Navigate to="/home/dashboard" />
    ) : (
      <Page component={Login} layout={"solo-page"} />
    ),
  },
  {
    path: "/forgotpassword",
    element: auth ? (
      <Navigate to="/home/dashboard" />
    ) : (
      <Page component={ForgotPassword} layout={"solo-page"} />
    ),
  },{
    path: "/resetpassword",
    element: auth ? (
      <Navigate to="/home/dashboard" />
    ) : (
      <Page component={ResetPassword} layout={"solo-page"} />
    ),
  },
];

export default AuthRoutes;
